/**
 * The LayerManager wraps your application and creates two adjacent divs for
 * rendering your application and housing Layers.
 */
import * as React from "react"
import styled from "@oui/system"
import LayerContext from "./LayerContext"

type Props = Readonly<{
  children: React.ReactNode
}>

const LayerHost = styled("div")`
  & > * > * {
    /* FIXME: required to be at a higher z-index than the savant panel. Should be 1 instead */
    z-index: 1011;
  }
`

const LayerManager = ({ children }: Props) => {
  const [host, setHost] = React.useState<HTMLDivElement | null>(null)

  return (
    <LayerContext.Provider value={{ host: host }}>
      <div>{children}</div>
      <LayerHost ref={setHost} />
    </LayerContext.Provider>
  )
}

export default React.memo(LayerManager)
